import styled from 'styled-components'

const Button = styled.button`
  font-family: Molde-bold;
  overflow: hidden;
  position: relative;
  background: ${props => props.color};
  float: left;
  color: white;
  padding: 0.5rem 1rem;
  border: none;
  letter-spacing: 0.5px;
  margin: 0;

  &:disabled {
    background: #999;
    cursor: not-allowed;
    opacity: 0.65;
  }
`

export default Button
